<template>
    <div class="viewACSTF" v-if="dados">
        <div class="modal-conteudo m-2">
            <div id="divImprimir">
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h4 class="txt-p txt-w-7 txt-size-16 mb-0"> {{dados.dsTitulo}}</h4>
                        <h4 class="txt-p txt-w-4 txt-size-14"> {{dados.dsSubTitulo}}</h4>
                    </div>
                    <div class="col-md-4 mt-2">
                        <h6 >Relator(a):</h6>
                        <span  v-html="dados.dsRelator"></span>
                    </div>
                    <div class="col-md-4" v-if="dados.dsRedatorAcordao">
                        <h6 >Relator(a) do Acórdão:</h6>
                        <span  v-html="dados.dsRedatorAcordao"></span >
                    </div>
                    <div class="col-md-4" v-if="dados.dsRevisor">
                        <h6 >Revisor:</h6>
                        <span  v-html="dados.dsRevisor"></span >
                    </div>
                    <div class="col-md-4">
                        <h6 >Julgamento:</h6>
                        <span  v-html="dados.dtJulgamento"></span >
                    </div>
                    <div class="col-md-4">
                        <h6 >Publicação:</h6>
                        <span  v-html="dados.dtPublicacao"></span >
                    </div>
                    <div class="col-md-4">
                        <h6 >Órgão julgador:</h6>
                        <span  v-html="dados.dsOrgaoJulgador"></span >
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12" v-if="dados.dsPublicacao">
                        <h6 >Publicação:</h6>
                        <span  v-html="dados.dsPublicacao"></span >
                    </div>
                    <div class="col-md-12" v-if="dados.dsEmenta">
                        <h6 >Ementa:</h6>
                        <span  v-html="dados.dsEmenta"></span >
                    </div>
                    <div class="col-md-12" v-if="dados.dsDecisao">
                        <h6 >Decisão:</h6>
                        <span  v-html="dados.dsDecisao"></span >
                    </div>
                    <div class="col-md-12" v-if="dados.dsTema">
                        <h6 >Tema:</h6>
                        <span  v-html="dados.dsTema"></span >
                    </div>
                    <div class="col-md-12" v-if="dados.dsIndexacao">
                        <h6 >Indexação:</h6>
                        <span  v-html="dados.dsIndexacao"></span >
                    </div>
                    <div class="col-md-12" v-if="dados.dsLegislacao">
                        <h6 >Legislação:</h6>
                        <span  v-html="dados.dsLegislacao"></span >
                    </div>
                    <div class="col-md-12" v-if="dados.dsObservacao">
                        <h6 >Observação:</h6>
                        <span  v-html="dados.dsObservacao"></span >
                    </div>
                    <div class="col-md-12" v-if="dados.dsDoutrina">
                        <h6 >Doutrina:</h6>
                        <span  v-html="dados.dsDoutrina"></span >
                    </div>
                </div>
                
            </div>
        </div>

        <div class="modal-footer pb-0 mt-4 d-flex justify-content-end">
            <a :href="dados.urlLink" class="btn-default bg-solid-primary txt-size-14" target="_blank"  v-if="dados.urlLink">
                <i class="fas fa-external-link-alt"></i> Acessar Acórdão
            </a>
            <a :href="dados.urlPdf" class="btn-default bg-solid-primary txt-size-14" target="_blank"  v-if="dados.urlPdf">
                <i class="fas fa-file-pdf"></i> Inteiro teor
            </a>

            <button class="btn-default bg-solid-primary txt-size-14" @click="imprimir">
                <i class="fas fa-print"></i> Imprimir
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'viewACSTF',
        components: { },
        data: function () {
            return {
                tpConteudo: 'Pesquisa',
                cdConteudo: 'ACSTF',
            }
        },
        props: {
            dados: Object,
        },
        methods: {
            
            imprimir() {
                var conteudo = document.getElementById('divImprimir').innerHTML,
                    tela_impressao = window.open('about:blank');

                tela_impressao.document.write(conteudo);
                tela_impressao.window.print();
                tela_impressao.window.close();
            },
        },
        mounted: function () {
        },
        watch: {
            dados: {
                handler() {
                },
                deep: true
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
   
</style>

